import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { TurnAroundTimeData } from '../services/dashboardApi';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

interface TurnAroundTimeChartProps {
  data: TurnAroundTimeData[];
  monthlyPerformance: Array<{ month: string; performance: string }>;
}

const TurnAroundTimeChart: React.FC<TurnAroundTimeChartProps> = ({ data: chartData, monthlyPerformance }) => {

    const data = {
      labels: chartData.map(item => item.month),
      datasets: [ 
        {
          label: 'Exceed Turn Around Time',
          data: chartData.map(item => item.exceed),
          backgroundColor: '#F64E60',
          borderRadius: 4,
          stack: 'tat', 
        },
        {
          label: 'Within Turn Around Time',
          data: chartData.map(item => item.within),
          backgroundColor: '#3699FF',
          borderRadius: 4,
          stack: 'tat', 
        },
      ],
    };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom' as const,
        labels: {
          usePointStyle: true,
          padding: 15,
          font: {
            size: 12,
          },
        },
      },
      title: {
        display: false,
      },
      tooltip: {
        backgroundColor: '#fff',
        titleColor: '#000',
        bodyColor: '#666',
        borderColor: '#ddd',
        borderWidth: 1,
        padding: 12,
        displayColors: true,
        callbacks: {
          label: function(context: any) {
            return context.dataset.label + ': ' + context.parsed.y;
          }
        }
      },
    },
    scales: {
      x: {
      stacked: true,
        grid: {
          display: false,
        },
        ticks: {
          font: {
            size: 11,
          },
        },
      },
      y: {
      stacked: true,
        beginAtZero: true,
        grid: {
          color: '#f0f0f0',
        },
        ticks: {
          font: {
            size: 11,
          },
        },
      },
    },
  };

  // Split data into two columns
  const midpoint = Math.ceil(monthlyPerformance.length / 2);
  const firstColumn = monthlyPerformance.slice(0, midpoint);
  const secondColumn = monthlyPerformance.slice(midpoint);

  return (
    <div className="card card-flush h-100 shadow-sm">
      <div className="card-header pt-7 pb-3">
        <h3 className="card-title align-items-start flex-column">
          <span className="card-label fw-bold text-gray-800">
            Turn Around Time Performance (Last 12 Months)
          </span>
        </h3>
      </div>
      <div className="card-body pt-2 pb-4">
        <div style={{ height: '350px' }}>
          <Bar data={data} options={options} />
        </div>
         <div className="row mt-4">
          <div className="col-md-6">
            <div className="table-responsive">
              <table className="table  table-row-dashed gy-4 gs-4">
                <thead>
                  <tr className="fw-bold text-gray-800 bg-light">
                    <th className="ps-4 rounded-start">Month</th>
                    <th className="pe-4 rounded-end">Performance</th>
                  </tr>
                </thead>
                <tbody>
                  {firstColumn.map((item, index) => (
                    <tr key={index}>
                      <td className="ps-4 text-gray-700">{item.month}</td>
                      <td className="pe-4 text-gray-700">{item.performance}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-6">
            <div className="table-responsive">
              <table className="table  table-row-dashed gy-4 gs-4">
                <thead>
                  <tr className="fw-bold text-gray-800 bg-light">
                    <th className="ps-4 rounded-start">Month</th>
                    <th className="pe-4 rounded-end">Performance</th>
                  </tr>
                </thead>
                <tbody>
                  {secondColumn.map((item, index) => (
                    <tr key={index}>
                      <td className="ps-4 text-gray-700">{item.month}</td>
                      <td className="pe-4 text-gray-700">{item.performance}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TurnAroundTimeChart;
